import React from "react";
import { withRouter } from "react-router";
// import {Link} from 'react-router-dom'
import { IMAGE_DOMAIN } from "config";
// import Carousel from 'react-owl-carousel'
import "./styles.css";

// const mrProductDetails = [
// 	{
// 		id: 1,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/1/01_800x1200.jpg`
// 		],
// 		name: '湛藍電水壺',
// 		code: '43128',
// 		price: 'NT. 3800',
// 		features: [
// 			'使用德國大廠Duran玻璃，可耐熱 -70~450℃，堅固耐用。',
// 			'加熱時呈現亮藍色透明壺身，體驗高雅奢華的視覺享受。',
// 			'煮沸自動斷電裝置，安全好安心。',
// 			'1.7公升加大容量，7分鐘快速沸騰。',
// 			'可拆式壺嘴濾網，阻擋水中石灰質及雜質，衛生飲用好健康。'
// 		],
// 		specs: [
// 			{ key: '容量', value: '1.7L' },
// 			{ key: '電壓', value: '110V' },
// 			{ key: '頻率', value: '60Hz' },
// 			{ key: '功率', value: '1500W' },
// 			{ key: '材質', value: '德國Duran玻璃' },
// 			{ key: '保固', value: '2年' },
// 			{ key: '產品尺寸', value: 'W160xH296xD222' },
// 			{ key: '單品重量', value: '1320g' },
// 			{ key: '產地', value: '中國' }
// 		]
// 	},
// 	{
// 		id: 2,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/2/01_800x1200.jpg`
// 		],
// 		name: '快煮笛音壺(鉻黃)',
// 		code: '43858',
// 		price: 'NT. 2950',
// 		features: [
// 			"304不鏽鋼材質，搭配英倫時尚設計，提升居家品味。",
// 			"1.5公升容量，7分鐘高速沸騰，省時省電。",
// 			"內建水位指示器，輕鬆得知壺內水量。",
// 			"煮沸時鳴笛聲提醒，並啟動斷電裝置。",
// 			"可拆式壺嘴濾網，阻擋水中雜質，可拆除清洗，衛生飲用。"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "1.5L" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1500W" },
// 			{ "key": "材質", "value": "304不鏽鋼" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W215xH270xD240" },
// 			{ "key": "單品重量", "value": "1292g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 3,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/3/01_800x1200.jpg`
// 		],
// 		name: '快煮笛音壺(紫)',
// 		code: '43854',
// 		price: 'NT. 2950',
// 		features: [
// 			"304不鏽鋼材質，搭配英倫時尚設計，提升居家品味。",
// 			"1.5公升容量，7分鐘高速沸騰，省時省電。",
// 			"內建水位指示器，輕鬆得知壺內水量。",
// 			"煮沸時鳴笛聲提醒，並啟動斷電裝置。",
// 			"可拆式壺嘴濾網，阻擋水中雜質，可拆除清洗，衛生飲用。"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "1.5L" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1500W" },
// 			{ "key": "材質", "value": "304不鏽鋼" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W215xH270xD240" },
// 			{ "key": "單品重量", "value": "1292g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 4,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/4/01_800x1200.jpg`
// 		],
// 		name: '快煮笛音壺(藍)',
// 		code: '43855',
// 		price: 'NT. 2950',
// 		features: [
// 			"304不鏽鋼材質，搭配英倫時尚設計，提升居家品味。",
// 			"1.5公升容量，7分鐘高速沸騰，省時省電。",
// 			"內建水位指示器，輕鬆得知壺內水量。",
// 			"煮沸時鳴笛聲提醒，並啟動斷電裝置。",
// 			"可拆式壺嘴濾網，阻擋水中雜質，可拆除清洗，衛生飲用。"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "1.5L" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1500W" },
// 			{ "key": "材質", "value": "304不鏽鋼" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W215xH270xD240" },
// 			{ "key": "單品重量", "value": "1292g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 5,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/5/01_800x1200.jpg`
// 		],
// 		name: '快煮笛音壺(紅)',
// 		code: '43857',
// 		price: 'NT. 2950',
// 		features: [
// 			"304不鏽鋼材質，搭配英倫時尚設計，提升居家品味。",
// 			"1.5公升容量，7分鐘高速沸騰，省時省電。",
// 			"內建水位指示器，輕鬆得知壺內水量。",
// 			"煮沸時鳴笛聲提醒，並啟動斷電裝置。",
// 			"可拆式壺嘴濾網，阻擋水中雜質，可拆除清洗，衛生飲用。"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "1.5L" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1500W" },
// 			{ "key": "材質", "value": "304不鏽鋼" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W215xH270xD240" },
// 			{ "key": "單品重量", "value": "1292g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 6,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/6/01_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/6/02_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/6/03_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/6/04_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/6/05_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/6/06_800x1200.jpg`
// 		],
// 		name: '即熱電水壺',
// 		code: '43923',
// 		price: 'NT. 4500',
// 		features: [
// 			"飲水品質好衛生：不重複煮沸，要喝多少煮多少，水質新鮮不變質。",
// 			"60秒即飲熱水：只需60～90秒，即可享有暖呼呼的熱開水。",
// 			"用水量自行設定：一次出水量150～300ml，咖啡杯或馬克杯均可。",
// 			"儲水量高達1.8L",
// 			"貼心照明燈，方便夜間飲用。"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "1.8L" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1400W" },
// 			{ "key": "材質", "value": "304不鏽鋼" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W160xH320xD300 " },
// 			{ "key": "單品重量", "value": "2365g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 7,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/7/01_800x1200.jpg`
// 		],
// 		name: 'BRITA快煮濾水壺(珍珠白)',
// 		code: '43965',
// 		price: 'NT. 2800',
// 		features: [
// 			"英國王牌小家電morphy richards X德國濾水專家BRITA 聯手推出『電熱濾水壺』，過濾加熱一機完成",
// 			"經BSMI、SGS檢驗認證合格，不含塑化劑，煮沸加熱不變質",
// 			"去除石灰質及重金屬，保留有益的礦物質",
// 			"通電時水量表呈藍光，輕鬆得知壺內水量",
// 			"設有煮沸自動斷電功能，安全又安心",
// 			"電子式濾芯更換顯示器，貼心提醒更換時間"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "1.5L" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1500W" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W175xH254xD255" },
// 			{ "key": "單品重量", "value": "1264g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 8,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/8/01_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/8/02_800x1200.jpg`
// 		],
// 		name: '沏茶壺',
// 		code: '43970',
// 		price: 'NT. 4500',
// 		features: [
// 			"獨家迴流式沖泡設計",
// 			"茶包不直接浸泡於水中，減少單寧酸及咖啡因釋出",
// 			"溫度控制鍵：85、95、100度可依不同茶種設定最佳口感的茶飲",
// 			"濃度控制鍵：定時2~6分鐘調整茶葉最佳濃度",
// 			"數位顯示幕會顯示所剩餘時間",
// 			"曲線造型玻璃壺身",
// 			"沏茶後自動保溫20分鐘"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "1L" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1400W" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W200xH280xD215" },
// 			{ "key": "單品重量", "value": "1470g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 9,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/9/01_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/9/02_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/9/03_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/9/04_800x1200.jpg`
// 		],
// 		name: '九段溫控不鏽鋼烤麵包機',
// 		code: '44742',
// 		price: 'NT. 2800',
// 		features: [
// 			"304不鏽鋼材質，搭配時尚設計，提升您的居家品味。",
// 			"加寬型彈性麵包槽，各種厚度麵包及貝果皆可烘烤",
// 			"九段式溫控烘烤設定。",
// 			"加高升降桿，烤小土司輕鬆上手。",
// 			"烘烤中斷、解凍、重新加熱功能。",
// 			"底座配有麵包集屑盤，清理更方便。"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "兩片式" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "900W" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W206xH225xD320" },
// 			{ "key": "單品重量", "value": "1610g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 10,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/10/01_800x1200.jpg`
// 		],
// 		name: '滴漏咖啡機',
// 		code: '47140',
// 		price: 'NT. 4200',
// 		features: [
// 			"時尚簡約造型，獨家迴流智慧沖泡設計",
// 			"配有濃度控制鍵可設定咖啡濃度，依需求調整",
// 			"一次可煮4~8杯，自動保溫一小時。",
// 			"兩段式控溫(85/95度)，滿足您對咖啡口感的喜好",
// 			"壺身採用德國DURAN玻璃，堅固耐用好安心"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "1.5L" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1200W" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W200xH275xD205" },
// 			{ "key": "單品重量", "value": "1430g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 11,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/11/01_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/11/02_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/11/03_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/11/04_800x1200.jpg`
// 		],
// 		name: '全自動智慧型製麵包機',
// 		code: '48319',
// 		price: 'NT. 7600',
// 		features: [
// 			"輕鬆入門：19種內建麵包程式設定，高達48種食譜，選擇程式後，只需一鍵，輕鬆完成。",
// 			"專業級使用：獨家＂手工製作＂程式，可自行研發並記憶獨門配方，製作屬於自己的麵包。",
// 			"超大水果堅果自動投擲裝置，確保食材在黃金時間置入。",
// 			"全球獨創自動摺疊麵糰攪拌片，烘培出形狀完美的麵包。",
// 			"預約設定,最長可達12小時；烘培完成後，自動保溫60分鐘。",
// 			"可設定3種麵包大小及5種烤色設定,隨自己喜好設定。",
// 			"業界最快，70分鐘熱騰騰麵包快速出爐。",
// 			"不鏽鋼外身,質感佳且容易清洗，觸控螢幕上，設計符合人體工學的斜角,清楚看,好觸控。"
// 		],
// 		specs: [
// 			{ "key": "容量", "value": "2L" },
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "615W" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W375xH330xD290" },
// 			{ "key": "單品重量", "value": "6047g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 12,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/12/01_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/02_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/03_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/04_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/05_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/06_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/07_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/08_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/09_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/10_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/11_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/12_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/13_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/14_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/15_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/16_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/12/17_800x1200.jpg`
// 		],
// 		name: '12合1複合式蒸氣拖把',
// 		code: '720027',
// 		price: 'NT. 6800',
// 		features: [
// 			"12種專用接頭配件，一把搞定各式頑垢",
// 			"可自行加入愛用的香氛清潔液，清潔環境同時擁有舒適心情",
// 			"可拆式直立/手持手把，靈活運用於各種表面清潔",
// 			"可替換式水垢過濾盒: 吸附水中石灰質，延長蒸氣拖把使用壽命",
// 			"300ml水箱容量，可連續使用12分鐘，蒸氣大小自由控制",
// 			"快速熱機: 僅需30秒加熱時間即可使用",
// 			"高溫蒸氣可達125~150°C，有效殺死塵蹣細菌",
// 			"環保地板布套: 可拆式地板套可丟洗衣機清洗，重複使用清潔又環保",
// 			"水槽容量高達400公克，富含低水位重力金屬球，少量水也能正常使用"
// 		],
// 		specs: [
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1200W" },
// 			{ "key": "電線長度", "value": "5M" },
// 			{ "key": "尺寸", "value": "直立式組裝後117.5cm" },
// 			{ "key": "出蒸氣時間", "value": "30秒快速出蒸氣" },
// 			{ "key": "內附", "value": "微纖維地板套*2、微纖維硬板套*2及各種接頭配件" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W280xH1175xD220" },
// 			{ "key": "單品重量", "value": "3160g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	},
// 	{
// 		id: 13,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}morphyrichards/13/01_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/02_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/03_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/04_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/05_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/06_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/07_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/08_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/09_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/10_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/11_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/12_800x1200.jpg`,
// 			`${IMAGE_DOMAIN}morphyrichards/13/13_800x1200.jpg`
// 		],
// 		name: '9合1複合式蒸氣拖把',
// 		code: '720020',
// 		price: 'NT. 6500',
// 		features: [
// 			"以蒸氣殺死細菌及微生物，不需使用化學藥劑",
// 			"以強力蒸氣清除各式油垢和居家髒汙，也能熨燙衣物、床被及布沙發表面",
// 			"使用於各式地面(包括地毯、木質地磚、塑膠地板、天然石)，不留水痕",
// 			"羽量級3公斤直立式設計輕巧，內建9種功能配件",
// 			"熱機時間僅需30秒，強力蒸氣不間斷，可自行控制蒸氣量",
// 			"水槽容量高達400公克，富含低水位重力金屬球，少量水也能正常使用"
// 		],
// 		specs: [
// 			{ "key": "電壓", "value": "110V" },
// 			{ "key": "頻率", "value": "60Hz" },
// 			{ "key": "功率", "value": "1200W" },
// 			{ "key": "電線長度", "value": "5M" },
// 			{ "key": "尺寸", "value": "直立式組裝後110*30*14cm" },
// 			{ "key": "出蒸氣時間", "value": "30秒快速出蒸氣" },
// 			{ "key": "內附", "value": "微纖維地板套*2及接頭配件" },
// 			{ "key": "保固", "value": "2年" },
// 			{ "key": "產品尺寸", "value": "W300xH1100xD140" },
// 			{ "key": "單品重量", "value": "3000g" },
// 			{ "key": "產地", "value": "中國" }
// 		]
// 	}
// ]

// const microdryProductDtls = [
// 	{
// 		id: 1,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}microdry/0/01.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/02.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/03.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/04.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/05.jpg`
// 		],
// 		name: 'Microdry《aerocore Bath Mat》快乾記憶綿浴墊【時尚黑/ S】',
// 		code: '',
// 		price: 'NT. 790',
// 		discountPrice: 'NT. 399',
// 		features: [
// 			'3D透氣蜂巢狀纖維，透氣透水性能最高評比',
// 			'快速乾爽不回滲， 透氣透水性能最高評比 ',
// 			'太空記憶綿夾層，使足部舒適減壓',
// 			'表層抗UV面料長時間不褪色',
// 			'可機洗不易變形'
// 		],
// 		specs: [
// 			{ key: '產品尺寸(S)', value: '43x61cm' }
// 		]
// 	},
// 	{
// 		id: 2,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}microdry/0/01.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/02.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/03.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/04.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/05.jpg`
// 		],
// 		name: 'Microdry《aerocore Bath Mat》快乾記憶綿浴墊【沉穗褐/ S】',
// 		code: '',
// 		price: 'NT. 790',
// 		discountPrice: 'NT. 399',
// 		features: [
// 			'3D透氣蜂巢狀纖維，透氣透水性能最高評比',
// 			'快速乾爽不回滲， 透氣透水性能最高評比 ',
// 			'太空記憶綿夾層，使足部舒適減壓',
// 			'表層抗UV面料長時間不褪色',
// 			'可機洗不易變形'
// 		],
// 		specs: [
// 			{ key: '產品尺寸(S)', value: '43x61cm' }
// 		]
// 	},
// 	{
// 		id: 3,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}microdry/0/01.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/02.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/03.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/04.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/05.jpg`
// 		],
// 		name: 'Microdry《aerocore Bath Mat》快乾記憶綿浴墊【銀宇灰/ S】',
// 		code: '',
// 		price: 'NT. 790',
// 		discountPrice: 'NT. 399',
// 		features: [
// 			'3D透氣蜂巢狀纖維，透氣透水性能最高評比',
// 			'快速乾爽不回滲， 透氣透水性能最高評比 ',
// 			'太空記憶綿夾層，使足部舒適減壓',
// 			'表層抗UV面料長時間不褪色',
// 			'可機洗不易變形'
// 		],
// 		specs: [
// 			{ key: '產品尺寸(S)', value: '43x61cm' }
// 		]
// 	},
// 	{
// 		id: 4,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}microdry/0/01.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/02.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/03.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/04.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/05.jpg`
// 		],
// 		name: 'Microdry《aerocore Bath Mat》快乾記憶綿浴墊【復刻藍/ S】',
// 		code: '',
// 		price: 'NT. 790',
// 		discountPrice: 'NT. 399',
// 		features: [
// 			'3D透氣蜂巢狀纖維，透氣透水性能最高評比',
// 			'快速乾爽不回滲， 透氣透水性能最高評比 ',
// 			'太空記憶綿夾層，使足部舒適減壓',
// 			'表層抗UV面料長時間不褪色',
// 			'可機洗不易變形'
// 		],
// 		specs: [
// 			{ key: '產品尺寸(S)', value: '43x61cm' }
// 		]
// 	},
// 	{
// 		id: 5,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}microdry/0/01.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/02.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/03.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/04.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/05.jpg`
// 		],
// 		name: 'Microdry《aerocore Bath Mat》快乾記憶綿浴墊【時尚黑/ L】',
// 		code: '',
// 		price: 'NT. 980',
// 		discountPrice: 'NT. 499',
// 		features: [
// 			'3D透氣蜂巢狀纖維，透氣透水性能最高評比',
// 			'快速乾爽不回滲， 透氣透水性能最高評比 ',
// 			'太空記憶綿夾層，使足部舒適減壓',
// 			'表層抗UV面料長時間不褪色',
// 			'可機洗不易變形'
// 		],
// 		specs: [
// 			{ key: '產品尺寸(L)', value: '51x86cm' }
// 		]
// 	},
// 	{
// 		id: 6,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}microdry/0/01.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/02.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/03.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/04.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/05.jpg`
// 		],
// 		name: 'Microdry《aerocore Bath Mat》快乾記憶綿浴墊【沉穗褐/ L】',
// 		code: '',
// 		price: 'NT. 980',
// 		discountPrice: 'NT. 499',
// 		features: [
// 			'3D透氣蜂巢狀纖維，透氣透水性能最高評比',
// 			'快速乾爽不回滲， 透氣透水性能最高評比 ',
// 			'太空記憶綿夾層，使足部舒適減壓',
// 			'表層抗UV面料長時間不褪色',
// 			'可機洗不易變形'
// 		],
// 		specs: [
// 			{ key: '產品尺寸(L)', value: '51x86cm' }
// 		]
// 	},
// 	{
// 		id: 7,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}microdry/0/01.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/02.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/03.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/04.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/05.jpg`
// 		],
// 		name: 'Microdry《aerocore Bath Mat》快乾記憶綿浴墊【銀宇灰/ L】',
// 		code: '',
// 		price: 'NT. 980',
// 		discountPrice: 'NT. 499',
// 		features: [
// 			'3D透氣蜂巢狀纖維，透氣透水性能最高評比',
// 			'快速乾爽不回滲， 透氣透水性能最高評比 ',
// 			'太空記憶綿夾層，使足部舒適減壓',
// 			'表層抗UV面料長時間不褪色',
// 			'可機洗不易變形'
// 		],
// 		specs: [
// 			{ key: '產品尺寸(L)', value: '51x86cm' }
// 		]
// 	},
// 	{
// 		id: 8,
// 		imgUrls: [
// 			`${IMAGE_DOMAIN}microdry/0/01.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/02.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/03.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/04.jpg`,
// 			`${IMAGE_DOMAIN}microdry/0/05.jpg`
// 		],
// 		name: 'Microdry《aerocore Bath Mat》快乾記憶綿浴墊【復刻藍/ L】',
// 		code: '',
// 		price: 'NT. 980',
// 		discountPrice: 'NT. 499',
// 		features: [
// 			'3D透氣蜂巢狀纖維，透氣透水性能最高評比',
// 			'快速乾爽不回滲， 透氣透水性能最高評比 ',
// 			'太空記憶綿夾層，使足部舒適減壓',
// 			'表層抗UV面料長時間不褪色',
// 			'可機洗不易變形'
// 		],
// 		specs: [
// 			{ key: '產品尺寸(L)', value: '51x86cm' }
// 		]
// 	}
// ]

const askoProductDtls = [
  {
    id: 1,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/1/00.png`,
      `${IMAGE_DOMAIN}asko/1/01.png`,
      `${IMAGE_DOMAIN}asko/1/02.png`,
      `${IMAGE_DOMAIN}asko/1/03.png`,
      `${IMAGE_DOMAIN}asko/1/04.png`,
      `${IMAGE_DOMAIN}asko/1/05.png`,
    ],
    name: "RFN2386SR / L",
    code: "",
    price: "NT. 88,000",
    features: ["釋放負離子", "保持箱內空氣清新如郊外", "保持生蔬清香氣味"],
    specs: [
      { key: "急速降溫功能", value: "冷藏、冷凍皆具" },
      {
        key: "清新空氣設計",
        value: "釋放負離子，保持箱內空氣清新如郊外，保持生蔬清香氣味",
      },
      { key: "面料", value: "VZ065 不鏽鋼刷絲，加防止印處理" },
      { key: "噪音度", value: "38dB(A)  re 1 pw（極低值）" },
      { key: "能源因數值", value: "23.4（極低值）" },
      { key: "年耗能", value: "192.0 kWh/Jahr（極低值）" },
      { key: "能源效率等級", value: "1 級" },
      { key: "淨容量", value: "302公升（冷藏室222公升 + 冷凍室80公升）" },
      { key: "環保冷媒", value: "R600a（非一班R134a）" },
      {
        key: "尺寸",
        value: "185公分（高）x 64公分（深）x 60公分（寬）; 開門寬度64.4公分",
      },
      { key: "用電資訊", value: "電壓：220V, 頻率：60Hz, 電流：10A" },
      { key: "淨重", value: "73公斤" },
      { key: "溫度區間", value: "-24度（最低）至+9度（最高）" },
    ],
  },
  {
    id: 2,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/2/00.png`,
      `${IMAGE_DOMAIN}asko/2/01.png`,
      `${IMAGE_DOMAIN}asko/2/02.png`,
      `${IMAGE_DOMAIN}asko/2/03.png`,
    ],
    name: "DBI133I.W / S",
    code: "",
    price: "NT. 69,000 / 74,000",
    features: [
      "兒童安全鎖",
      "濾網自動清洗系統（SCS+）",
      "濁度感應器",
      "軟水氣",
      "防漏偵測系統",
    ],
    specs: [
      { key: "安裝型式", value: "獨立" },
      { key: "容量（人份）", value: "13 / 15" },
      { key: "顯示幕形式", value: "機門前方LCD" },
      { key: "顏色", value: "白色" },
      { key: "噪音值（dB(A)）", value: "44" },
      { key: "產品尺寸", value: "寬：596 / 深：600 / 高(861 ~ 902)" },
      { key: "消耗功率（W）", value: "1300" },
      { key: "電壓（V）", value: "110" },
      { key: "電流（A）", value: "15" },
      { key: "頻率（Hz）", value: "60" },
      { key: "能源效率評鑑", value: "A+++" },
      { key: "乾淨效率評鑑", value: "A" },
      { key: "烘乾效率評鑑", value: "A" },
      { key: "噴水臂數量", value: "2" },
      { key: "碗籃數量", value: "2" },
    ],
  },
  {
    id: 3,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/3/00.png`,
      `${IMAGE_DOMAIN}asko/3/01.png`,
      `${IMAGE_DOMAIN}asko/3/02.png`,
      `${IMAGE_DOMAIN}asko/3/03.png`,
    ],
    name: "DBI654IB.W / S",
    code: "",
    price: "NT. 88,000 / 93,000",
    features: [
      "兒童安全鎖",
      "洗程進度指示燈",
      "濾網自動清洗系統（SCS+）",
      "濁度感應器",
      "BLDC無碳刷靜音馬達",
      "軟水氣",
      "上層碗籃卡扣設計，用於卡住塑料製品",
      "花瓶及奶瓶罐托架",
      "前方可調整後方底座高度",
      "防漏偵測系統",
    ],
    specs: [
      { key: "安裝型式", value: "嵌入" },
      { key: "容量（人份）", value: "15 / 16" },
      { key: "顯示幕形式", value: "機門上方LCD" },
      { key: "顏色", value: "白色 / 不鏽鋼" },
      { key: "噪音值（dB(A)）", value: "42" },
      { key: "產品尺寸", value: "寬：596 / 深：559 / 高(819 ~ 872)" },
      { key: "消耗功率（W）", value: "1300" },
      { key: "電壓（V）", value: "110" },
      { key: "電流（A）", value: "15" },
      { key: "頻率（Hz）", value: "60" },
      { key: "能源效率評鑑", value: "A+++" },
      { key: "乾淨效率評鑑", value: "A" },
      { key: "烘乾效率評鑑", value: "A" },
      { key: "噴水臂數量", value: "2" },
      { key: "碗籃數量", value: "3" },
    ],
  },
  {
    id: 4,
    imgUrls: [`${IMAGE_DOMAIN}asko/4/00.png`, `${IMAGE_DOMAIN}asko/4/01.png`],
    name: "DFI633",
    code: "",
    price: "NT. 76,000",
    features: [
      "兒童安全鎖",
      "濾網自動清洗系統（SCS+）",
      "BLDC無碳刷靜音馬達",
      "前方可調整後方底座高度",
      "前方可調整門彈簧",
      "防漏偵測系統",
    ],
    specs: [
      { key: "安裝型式", value: "全嵌（限廚具行）" },
      { key: "容量（人份）", value: "13 / 15" },
      { key: "顯示幕形式", value: "機門上方LCD" },
      { key: "噪音值（dB(A)）", value: "44" },
      { key: "產品尺寸", value: "寬：596 / 深：559 / 高(821 ~ 872)" },
      { key: "消耗功率（W）", value: "1300" },
      { key: "電壓（V）", value: "110" },
      { key: "電流（A）", value: "15" },
      { key: "頻率（Hz）", value: "60" },
      { key: "能源效率評鑑", value: "A+++" },
      { key: "乾淨效率評鑑", value: "A" },
      { key: "烘乾效率評鑑", value: "A" },
      { key: "噴水臂數量", value: "2" },
      { key: "碗籃數量", value: "2" },
    ],
  },
  {
    id: 5,
    imgUrls: [`${IMAGE_DOMAIN}asko/5/00.png`, `${IMAGE_DOMAIN}asko/5/01.png`],
    name: "DFI654B",
    code: "",
    price: "NT. 92,000",
    features: [
      "兒童安全鎖",
      "洗程進度指示燈",
      "濾網自動清洗系統（SCS+）",
      "濁度感應器",
      "BLDC無碳刷靜音馬達",
      "軟水氣",
      "上層碗籃卡扣設計，用於卡住塑料製品",
      "花瓶及奶瓶罐托架",
      "前方可調整後方底座高度",
      "前方可調整門彈簧",
      "防漏偵測系統",
    ],
    specs: [
      { key: "安裝型式", value: "全嵌（限廚具行）" },
      { key: "容量（人份）", value: "15 / 16" },
      { key: "顯示幕形式", value: "機門上方LCD" },
      { key: "噪音值（dB(A)）", value: "42" },
      { key: "產品尺寸", value: "寬：596 / 深：559 / 高(819 ~ 872)" },
      { key: "消耗功率（W）", value: "1300" },
      { key: "電壓（V）", value: "110" },
      { key: "電流（A）", value: "15" },
      { key: "頻率（Hz）", value: "60" },
      { key: "能源效率評鑑", value: "A+++" },
      { key: "乾淨效率評鑑", value: "A" },
      { key: "烘乾效率評鑑", value: "A" },
      { key: "噴水臂數量", value: "2" },
      { key: "碗籃數量", value: "3" },
    ],
  },
  {
    id: 6,
    imgUrls: [`${IMAGE_DOMAIN}asko/6/00.png`, `${IMAGE_DOMAIN}asko/6/01.png`],
    name: "DFS133I.W",
    code: "",
    price: "NT. 72,000",
    features: [
      "兒童安全鎖",
      "濾網自動清洗系統（SCS+）",
      "濁度感應器",
      "軟水氣",
      "防漏偵測系統",
    ],
    specs: [
      { key: "安裝型式", value: "獨立" },
      { key: "容量（人份）", value: "13 / 15" },
      { key: "顯示幕形式", value: "機門前方LCD" },
      { key: "顏色", value: "白色" },
      { key: "噪音值（dB(A)）", value: "44" },
      { key: "產品尺寸", value: "寬：596 / 深：600 / 高(861 ~ 902)" },
      { key: "消耗功率（W）", value: "1300" },
      { key: "電壓（V）", value: "110" },
      { key: "電流（A）", value: "15" },
      { key: "頻率（Hz）", value: "60" },
      { key: "能源效率評鑑", value: "A+++" },
      { key: "乾淨效率評鑑", value: "A" },
      { key: "烘乾效率評鑑", value: "A" },
      { key: "噴水臂數量", value: "2" },
      { key: "碗籃數量", value: "2" },
    ],
  },
  {
    id: 7,
    imgUrls: [`${IMAGE_DOMAIN}asko/7/00.png`, `${IMAGE_DOMAIN}asko/7/01.png`],
    name: "DFS143I.S",
    code: "",
    price: "NT. 84,000",
    features: [
      "兒童安全鎖",
      "濾網自動清洗系統（SCS+）",
      "濁度感應器",
      "BLDC無碳刷靜音馬達",
      "軟水氣",
      "防漏偵測系統",
    ],
    specs: [
      { key: "安裝型式", value: "獨立" },
      { key: "容量（人份）", value: "14 / 16" },
      { key: "顯示幕形式", value: "機門前方LCD" },
      { key: "顏色", value: "不鏽鋼" },
      { key: "噪音值（dB(A)）", value: "44" },
      { key: "產品尺寸", value: "寬：596 / 深：600 / 高(861 ~ 902)" },
      { key: "消耗功率（W）", value: "1300" },
      { key: "電壓（V）", value: "110" },
      { key: "電流（A）", value: "15" },
      { key: "頻率（Hz）", value: "60" },
      { key: "能源效率評鑑", value: "A+++" },
      { key: "乾淨效率評鑑", value: "A" },
      { key: "烘乾效率評鑑", value: "A" },
      { key: "噴水臂數量", value: "2" },
      { key: "碗籃數量", value: "3" },
    ],
  },
  {
    id: 8,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/8/00.png`,
      `${IMAGE_DOMAIN}asko/8/01.png`,
      `${IMAGE_DOMAIN}asko/8/02.png`,
      `${IMAGE_DOMAIN}asko/8/03.png`,
      `${IMAGE_DOMAIN}asko/8/04.png`,
      `${IMAGE_DOMAIN}asko/8/05.png`,
      `${IMAGE_DOMAIN}asko/8/06.png`,
    ],
    name: "W2084C.W.TW",
    code: "",
    price: "NT. 66,000",
    features: [
      "BLDC無碳刷靜音馬達",
      "Acitve Drum 強力滾筒 - 沙漏葉板效應（洗淨又護衣）",
      "Quattro 四腳鑄鐵配重避震",
      "Steel Seal 鋼圈超薄防刮玻璃門 - 門內無重疊橡皮肚圈，不會藏污納垢及發霉，超薄防水膠圈在門外，增加滾筒空間保障衛生",
    ],
    specs: [
      { key: "顏色", value: "白色" },
      { key: "省電效率評鑑", value: "A+++" },
      { key: "省水標章", value: "金級" },
      { key: "洗淨效率評鑑", value: "A" },
      { key: "脫水效率評鑑", value: "B" },
      { key: "電力消耗", value: "0.2千瓦小時/公斤" },
      { key: "耗水量", value: "68公升" },
      { key: "脫水轉速", value: "1400rpm" },
      { key: "脫水後衣物濕度殘留度", value: "48%" },
      { key: "噪音值", value: "51 / 75 db(A)" },
      { key: "最大洗衣容量", value: "8公斤" },
      { key: "機體尺寸", value: "高：850mm, 寬：595mm, 深：580mm" },
      { key: "重量", value: "75公斤" },
      { key: "額定電壓", value: "220V" },
      { key: "額定頻率", value: "60Hz" },
      { key: "電流", value: "10A" },
      { key: "最大功率", value: "2000W" },
      { key: "可調高度", value: "1cm" },
      { key: "排水管", value: "1.6m 聚丙烯管" },
      { key: "進水管", value: "1.5m PEX軟管" },
      { key: "顯示幕形式", value: "LCD(FSTN)" },
    ],
  },
  {
    id: 9,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/9/00.png`,
      `${IMAGE_DOMAIN}asko/9/01.png`,
      `${IMAGE_DOMAIN}asko/9/02.png`,
      `${IMAGE_DOMAIN}asko/9/03.png`,
      `${IMAGE_DOMAIN}asko/9/04.png`,
      `${IMAGE_DOMAIN}asko/9/05.png`,
      `${IMAGE_DOMAIN}asko/9/06.png`,
    ],
    name: "W4086C.W.TW",
    code: "",
    price: "NT. 88,000",
    features: [
      "BLDC無碳刷靜音馬達",
      "Acitve Drum 強力滾筒 - 沙漏葉板效應（洗淨又護衣）",
      "Quattro 四腳鑄鐵配重避震",
      "Steel Seal 鋼圈超薄防刮玻璃門 - 門內無重疊橡皮肚圈，不會藏污納垢及發霉，超薄防水膠圈在門外，增加滾筒空間保障衛生",
    ],
    specs: [
      { key: "顏色", value: "白色" },
      { key: "省電效率評鑑", value: "A+++" },
      { key: "省水標章", value: "金級" },
      { key: "洗淨效率評鑑", value: "A" },
      { key: "脫水效率評鑑", value: "A" },
      { key: "電力消耗", value: "0.2千瓦小時/公斤" },
      { key: "耗水量", value: "68公升" },
      { key: "脫水轉速", value: "1600rpm" },
      { key: "脫水後衣物濕度殘留度", value: "44%" },
      { key: "噪音值", value: "49 / 77 db(A)" },
      { key: "最大洗衣容量", value: "8公斤" },
      { key: "機體尺寸", value: "高：850mm, 寬：595mm, 深：580mm" },
      { key: "重量", value: "75.5公斤" },
      { key: "額定電壓", value: "220V" },
      { key: "額定頻率", value: "60Hz" },
      { key: "電流", value: "10A" },
      { key: "最大功率", value: "2000W" },
      { key: "可調高度", value: "1cm" },
      { key: "排水管", value: "1.6m 聚丙烯管" },
      { key: "進水管", value: "1.5m PEX軟管" },
      { key: "顯示幕形式", value: "LCD(FSTN)" },
    ],
  },
  {
    id: 10,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/10/00.png`,
      `${IMAGE_DOMAIN}asko/10/01.png`,
      `${IMAGE_DOMAIN}asko/10/02.png`,
      `${IMAGE_DOMAIN}asko/10/03.png`,
      `${IMAGE_DOMAIN}asko/10/04.png`,
      `${IMAGE_DOMAIN}asko/10/05.png`,
      `${IMAGE_DOMAIN}asko/10/06.png`,
    ],
    name: "W4114C.W.TW",
    code: "",
    price: "NT. 99,800",
    features: [
      "BLDC無碳刷靜音馬達",
      "Acitve Drum 強力滾筒 - 沙漏葉板效應（洗淨又護衣）",
      "Quattro 四腳鑄鐵配重避震",
      "Steel Seal 鋼圈超薄防刮玻璃門 - 門內無重疊橡皮肚圈，不會藏污納垢及發霉，超薄防水膠圈在門外，增加滾筒空間保障衛生",
    ],
    specs: [
      { key: "顏色", value: "白色" },
      { key: "省電效率評鑑", value: "A+++" },
      { key: "省水標章", value: "金級" },
      { key: "洗淨效率評鑑", value: "A" },
      { key: "脫水效率評鑑", value: "B" },
      { key: "電力消耗", value: "0.2千瓦小時/公斤" },
      { key: "耗水量", value: "92公升" },
      { key: "脫水轉速", value: "1400rpm" },
      { key: "脫水後衣物濕度殘留度", value: "48%" },
      { key: "噪音值", value: "52 / 74 db(A)" },
      { key: "最大洗衣容量", value: "11公斤" },
      { key: "機體尺寸", value: "高：850mm, 寬：595mm, 深：695mm" },
      { key: "重量", value: "88公斤" },
      { key: "額定電壓", value: "220V" },
      { key: "額定頻率", value: "60Hz" },
      { key: "電流", value: "10A" },
      { key: "最大功率", value: "2000W" },
      { key: "可調高度", value: "1cm" },
      { key: "排水管", value: "1.6m 聚丙烯管" },
      { key: "進水管", value: "1.5m PEX軟管" },
      { key: "顯示幕形式", value: "LCD(FSTN)" },
    ],
  },
  {
    id: 11,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/11/00.png`,
      `${IMAGE_DOMAIN}asko/11/01.png`,
      `${IMAGE_DOMAIN}asko/11/02.png`,
      `${IMAGE_DOMAIN}asko/11/03.png`,
      `${IMAGE_DOMAIN}asko/11/04.png`,
    ],
    name: "T208C.W",
    code: "",
    price: "NT. 72,000",
    features: [
      "一體成型面板",
      "不鏽鋼滾筒（鋼珠軸承）",
      "不鏽鋼底座及腳座",
      "無碳刷馬達及排水泵",
      "無碳刷馬達及排水泵排水",
      "Butterfly DryingAir Lift",
      "Soft Drum",
      "不需排風管打洞",
      "不釋出水汽到室內",
    ],
    specs: [
      { key: "省電效率評鑑", value: "B" },
      { key: "烘乾模式", value: "冷凝式" },
      { key: "額定電壓", value: "220V" },
      { key: "額定頻率", value: "60Hz" },
      { key: "電流", value: "16A" },
      { key: "最大功率", value: "2800W" },
      { key: "顏色", value: "白色" },
      { key: "顯示幕形式", value: "LCD(FSTN)" },
      { key: "滾筒容量", value: "117公升" },
      { key: "乾衣容量", value: "8公斤" },
      { key: "機體尺寸", value: "高：595mm, 寬：845mm, 深：640mm" },
      { key: "重量", value: "44公斤" },
      { key: "噪音值", value: "65 db(A)" },
      { key: "開門深度", value: "107.4cm" },
      { key: "可調高度", value: "1cm" },
      { key: "電力消耗", value: "0.58千瓦小時/公斤" },
    ],
  },
  {
    id: 12,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/12/00.png`,
      `${IMAGE_DOMAIN}asko/12/01.png`,
      `${IMAGE_DOMAIN}asko/12/02.png`,
      `${IMAGE_DOMAIN}asko/12/03.png`,
      `${IMAGE_DOMAIN}asko/12/04.png`,
      `${IMAGE_DOMAIN}asko/12/05.png`,
      `${IMAGE_DOMAIN}asko/12/06.png`,
    ],
    name: "T411HD",
    code: "",
    price: "NT. 99,800",
    features: [
      "一體成型面板",
      "不鏽鋼滾筒（鋼珠軸承）",
      "不鏽鋼底座及腳座",
      "無碳刷馬達及排水泵",
      "無碳刷馬達及排水泵排水",
      "Butterfly DryingAir Lift",
      "Soft Drum",
      "極省電",
      "不釋出熱氣 / 水汽到室內",
      "不影響冷氣效率，節省空間",
      "可在較不通風條件下運作",
    ],
    specs: [
      { key: "省電效率評鑑", value: "A++" },
      { key: "烘乾模式", value: "熱泵冷凝式" },
      { key: "額定電壓", value: "220V" },
      { key: "額定頻率", value: "60Hz" },
      { key: "電流", value: "10A" },
      { key: "最大功率", value: "900W" },
      { key: "顏色", value: "白色" },
      { key: "顯示幕形式", value: "LCD(FSTN)" },
      { key: "滾筒容量", value: "145公升" },
      { key: "乾衣容量", value: "11公斤" },
      { key: "機體尺寸", value: "高：595mm, 寬：845mm, 深：755mm" },
      { key: "重量", value: "57公斤" },
      { key: "噪音值", value: "65 db(A)" },
      { key: "開門深度", value: "118.9cm" },
      { key: "可調高度", value: "1cm" },
      { key: "電力消耗", value: "0.20千瓦小時/公斤" },
    ],
  },
  {
    id: 13,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/13/00.png`,
      `${IMAGE_DOMAIN}asko/13/01.png`,
      `${IMAGE_DOMAIN}asko/13/02.png`,
      `${IMAGE_DOMAIN}asko/13/03.png`,
      `${IMAGE_DOMAIN}asko/13/04.png`,
      `${IMAGE_DOMAIN}asko/13/05.png`,
      `${IMAGE_DOMAIN}asko/13/06.png`,
      `${IMAGE_DOMAIN}asko/13/07.png`,
    ],
    name: "OCS8456S / OCS8476S",
    code: "",
    price: "NT. 95,000 / 115,000",
    features: [
      "全方位加熱模式",
      "快速預熱模式",
      "烘烤濕度控制",
      "內建食譜功能",
      "分段式烹調設定",
      "解凍 / 保溫 / 暖盤",
      "我的最愛功能鍵",
      "定時除鈣提醒",
      "蒸氣清潔功能",
      "電子鐘兼計時器",
      "閒置關機系統",
      "全程內部照明",
      "24小時預約定時",
      "操作面板鎖定裝置",
    ],
    specs: [
      { key: "操作介面", value: "旋鈕式 / 全彩觸控式TFT" },
      { key: "機體尺寸(mm)", value: "W595xD566xH455" },
      { key: "安裝尺寸(mm)", value: "W560xD550xH450" },
      { key: "電壓", value: "220V" },
      { key: "頻率", value: "60Hz" },
      { key: "功率", value: "2900W" },
      { key: "電流", value: "14A" },
      { key: "容量", value: "51L" },
      { key: "烘焙層數", value: "4層" },
      { key: "蒸氣 + 熱風循環溫度", value: "30~230度" },
      { key: "烘烤最高溫度", value: "230度" },
      { key: "預熱最高溫度", value: "230度" },
      { key: "強化玻璃", value: "3層" },
      { key: "節能效率評鑑", value: "A" },
      { key: "全身縮導軌", value: "1層" },
      { key: "普通導軌", value: "3層" },
      { key: "搪瓷淺烤盤", value: "1個" },
      { key: "不鏽鋼深實心蒸烤盤", value: "1個" },
      { key: "不鏽鋼深帶孔蒸烤盤", value: "1個" },
      { key: "烘焙烤架", value: "1個" },
    ],
  },
  {
    id: 14,
    imgUrls: [
      `${IMAGE_DOMAIN}asko/14/00.png`,
      `${IMAGE_DOMAIN}asko/14/01.png`,
      `${IMAGE_DOMAIN}asko/14/02.png`,
      `${IMAGE_DOMAIN}asko/14/03.png`,
      `${IMAGE_DOMAIN}asko/14/04.png`,
      `${IMAGE_DOMAIN}asko/14/05.png`,
      `${IMAGE_DOMAIN}asko/14/06.png`,
      `${IMAGE_DOMAIN}asko/14/07.png`,
      `${IMAGE_DOMAIN}asko/14/08.png`,
      `${IMAGE_DOMAIN}asko/14/09.png`,
      `${IMAGE_DOMAIN}asko/14/10.png`,
      `${IMAGE_DOMAIN}asko/14/11.png`,
    ],
    name: "OCS8656S / OCS8676S",
    code: "",
    price: "NT. 115,000 / 145,000",
    features: [
      "全方位加熱模式",
      "快速預熱模式",
      "烘烤濕度控制",
      "內建食譜功能",
      "分段式烹調設定",
      "解凍 / 保溫 / 暖盤",
      "我的最愛功能鍵",
      "定時除鈣提醒",
      "蒸氣清潔功能",
      "電子鐘兼計時器",
      "閒置關機系統",
      "全程內部照明",
      "24小時預約定時",
      "操作面板鎖定裝置",
    ],
    specs: [
      { key: "操作介面", value: "旋鈕式 / 全彩觸控式TFT" },
      { key: "機體尺寸(mm)", value: "W595xD566xH595" },
      { key: "安裝尺寸(mm)", value: "W560xD550xH590" },
      { key: "電壓", value: "220V" },
      { key: "頻率", value: "60Hz" },
      { key: "功率", value: "3400W" },
      { key: "電流", value: "16A" },
      { key: "容量", value: "75L" },
      { key: "烘焙層數", value: "5層" },
      { key: "蒸氣 + 熱風循環溫度", value: "30~250度" },
      { key: "烘烤最高溫度", value: "250度" },
      { key: "預熱最高溫度", value: "250度" },
      { key: "強化玻璃", value: "3層" },
      { key: "節能效率評鑑", value: "A" },
      { key: "全身縮導軌", value: "3層" },
      { key: "普通導軌", value: "2層" },
      { key: "搪瓷淺烤盤", value: "2個" },
      { key: "搪瓷深烤盤", value: "1個" },
      { key: "不鏽鋼深實心蒸烤盤", value: "1個" },
      { key: "不鏽鋼深帶孔蒸烤盤", value: "1個" },
      { key: "烘焙烤架", value: "1個" },
      { key: "溫度探針", value: "1個" },
    ],
  },
];

class ProductDetail extends React.Component {
  // static propTypes = {
  //   position: PropTypes.oneOf(['fixed', 'absolue', 'sticky'])
  // }

  componentDidMount() {
    document.title = "Product Detail";
    window.scrollTo(0, 0);
  }

  render = () => {
    let productDetail;
    switch (this.props.match.params.brand) {
      // case 'microdry':
      // 	productDetail = microdryProductDtls[this.props.match.params.product - 1]
      // 	break
      case "asko":
        productDetail = askoProductDtls[this.props.match.params.product - 1];
        break;
      default:
      // productDetail = mrProductDetails[this.props.match.params.product - 1]
    }

    return (
      <section style={{ marginTop: "65px", padding: "30px 0" }}>
        <div className="container">
          <div className="row">
            <div className="shop-item-detail shop-item-detail-1">
              {this.renderSlider(productDetail.imgUrls)}
              <div className="col-md-4 col-md-offset-1 col-sm-6">
                {this.renderInfo(
                  productDetail.name,
                  productDetail.price,
                  productDetail.discountPrice
                )}
                {this.renderFeatures(productDetail.features)}
                {this.renderSpecs(productDetail.specs)}
                {/* {this.renderSocialShare()} */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  renderSlider = (imageUrls) => {
    let images;

    switch (imageUrls.length) {
      case 0:
        images = <div></div>;
        break;
      case 1:
        images = (
          <div>
            <img alt="product" src={imageUrls[0]} />
          </div>
        );
        break;
      default:
        images = (
          <div>
            <img alt="product" src={imageUrls[0]} />
          </div>
        );
      // images = (
      // 	<Carousel className="owl-theme" loop nav items={1} navText={['', '']}>
      // 		{
      // 			imageUrls.map((imageUrl, index) => (
      // 				<div key={index}><img alt="product" src={imageUrl} /></div>
      // 			))
      // 		}
      // 	</Carousel>
      // )
    }

    return <div className="col-sm-6">{images}</div>;
  };

  renderInfo = (name, price, discountPrice) => (
    <div>
      <div className="item__title">
        <h4>{name}</h4>
      </div>
      <div className="item__price" style={{ marginBottom: "2.36rem" }}>
        <span className={discountPrice ? "type--strikethrough" : ""}>
          {price}
        </span>
        <span>{discountPrice ? discountPrice : ""}</span>
      </div>
    </div>
  );

  renderFeatures = (productFeatures) => {
    const features = productFeatures.map((productFeature, index) => (
      <li key={index}>{productFeature}</li>
    ));

    return (
      <div className="item__description">
        <h5>商品特色:</h5>
        <ul className="item__list">{features}</ul>
      </div>
    );
  };

  renderSpecs = (productSpecs) => {
    const specs = productSpecs.map((productSpec, index) => (
      // <div key={index} className="item__subinfo">
      // 	<span>{productSpec.key}</span>
      // 	<span>{productSpec.value}</span>
      // </div>
      <tr key={index} className="item__subinfo">
        <td className="item__subinfo-label">{productSpec.key}</td>
        <td>{productSpec.value}</td>
      </tr>
    ));

    return (
      <div className="item__description">
        <h5>商品規格:</h5>
        <table>
          <tbody>{specs}</tbody>
        </table>
      </div>
    );
  };

  renderSocialShare = () => (
    <div className="item__description">
      <hr />
      <ul className="social-list">
        <li>
          <a role="button">
            <i className="socicon-twitter"></i>
          </a>
        </li>
        <li>
          <a role="button">
            <i className="socicon-facebook"></i>
          </a>
        </li>
        <li>
          <a role="button">
            <i className="socicon-pinterest"></i>
          </a>
        </li>
        <li>
          <a role="button">
            <i className="socicon-stumbleupon"></i>
          </a>
        </li>
      </ul>
    </div>
  );
}

export default withRouter(ProductDetail);



// WEBPACK FOOTER //
// ./src/containers/ProductDetail/index.js